import React from "react"
import ReactApexChart from "react-apexcharts"

const ActiveBarGraph = (props) => {
    const state = {
        series: props?.traffic_data
            ? [0, 0, 1]
            : [0, 0, 1],

        options: {
            chart: {
                // width:400,
                type: "donut",
            },
            labels: ["Web", "Android", "Apple"],
            fill: {
                opacity: 1,
                // colors: ["#001C35", "#00BA52", "#CE1036"],
            },
            stroke: {
                width: 0,
                colors: undefined,
            },
            yaxis: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                position: "bottom",
                markers: {
                    // fillColors: ["#001C35", "#00BA52", "#CE1036"],
                },
            },
            plotOptions: {
                polarArea: {
                    rings: {
                        strokeWidth: 0,
                    },
                },
            },
            // theme: {
            //   monochrome: {
            //     enabled: true,
            //     shadeTo: "light",
            //     shadeIntensity: 0.6,
            //   },
            // },
            colors: ["#001c35",
                "#004164",
                "#ECECEC",
                "#006b7e",
                "#009477",
                "#00ba52"],
        },
    }

    return (
        <div id="chart" className="apex-chart">
            <ReactApexChart
                options={state.options}
                series={state.series}
                type="donut"
                // height={251}
                // width={300}
            />
        </div>
    )
}

export default ActiveBarGraph
